var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_86)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_86",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 32,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2H32V3H0V2Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4H32V5H0V4Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H32V7H0V6Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H32V9H0V8Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H32V11H0V10Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H32V13H0V12Z",
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14H32V15H0V14Z",
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16H32V17H0V16Z",
    fill: "#111111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18H32V19H0V18Z",
    fill: "#111111"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H32V21H0V20Z",
    fill: "#111111"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22H32V23H0V22Z",
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24H32V25H0V24Z",
    fill: "#111111"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26H32V27H0V26Z",
    fill: "#111111"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H32V29H0V28Z",
    fill: "#111111"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30H32V31H0V30Z",
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32H32V33H0V32Z",
    fill: "#111111"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.15025 1.48H7.86225V4.008L3.35025 8.616V13H1.41425V8.024L5.92625 3.416V3.288H0.15025V1.48ZM10.72 1.48H14.576L15.856 3.416V5.656L14.512 7.064L15.856 9.064V10.888L13.856 13H9.6L8.144 10.856V8.824L9.504 7.496H9.408L8.144 5.624V4.168L10.72 1.48ZM10.08 5.272L10.528 5.96H13.04L13.92 5.096V3.768L13.584 3.288H11.488L10.08 4.728V5.272ZM10.08 10.504L10.544 11.192H13.04L13.92 10.328V9.416L12.8 7.768H11.648L10.08 9.416V10.504Z",
    fill: "#FF8800"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.84ee87b1776464039453467cd44e1c3d.svg";
export { ForwardRef as ReactComponent };